export default __webpack_public_path__ + "static/media/slider-bubble-white.39dc478c.svg";